import React from 'react';
import classnames from 'classnames';
import Address from './address';
import { AccentBackground } from 'scy/Background';
import { AccentHero, H2Alt, H6 } from 'scy/text';
import styles from './territories.mod.scss';

export default function Territories({ title, subtitle, onAddressSuccess }) {
  const addressInputId = 'address-input-secondary';

  return (
    <AccentBackground
      tag="section"
      className={classnames(styles.background, {
        [styles.backgroundPadding]: !title
      })}
    >
      {title ? (
        title
      ) : (
        <AccentHero className={styles.hero}>Saucey Territories</AccentHero>
      )}
      {subtitle ? (
        subtitle
      ) : (
        <H2Alt className={styles.subtitle}>
          On-demand 30-min delivery or 2-day shipping
        </H2Alt>
      )}
      <H6 tag="label" htmlFor={addressInputId} className={styles.label}>
        Enter your zip code to see your delivery options
      </H6>
      <Address
        scrollOnSubmit
        onSuccess={onAddressSuccess}
        trackingParams={{
          page: 'Homepage',
          source: 'Homepage Secondary'
        }}
        className={styles.address}
        id={addressInputId}
      />
    </AccentBackground>
  );
}
